export type ApiSupport = {
    isLoading?: boolean
    isLoaded?: boolean
    isFetching?: boolean
    isError?: boolean,
    fetchSuccess?: boolean,
    errorMessage?: string,
}

export const ApiSupportSelector = (state) => {
    return {
        isLoading: state.isLoading,
        isLoaded: state.isLoaded,
        isFetching: state.isFetching,
    }
}


// WEBPACK FOOTER //
// ./src/state/helpers/apiSupport.ts